import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossierHistorical/${dossierId}/entity`, method: 'GET', token: token })
}
